import {DropdownFieldOptions} from "../../../../../types/form/controls"
import {getRegions} from "../../../../../services/utility/geography/get-regions"

export const composeRegionOptions = (countryCode: string): DropdownFieldOptions => {
    return getRegions(countryCode).map(({shortCode, name}) => ({ id: shortCode, name}))
}
